"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPages = void 0;
const qrcode_1 = __importDefault(require("qrcode"));
const ua_1 = require("./libs/ua");
const util_1 = require("./libs/util");
const doms = {
    pages: [],
};
function generatePages(data) {
    const pages = data
        .map((config, i) => {
        const { bgImage, title, desc, poster } = config;
        return `
      <li class="page slide-item"  style="background-image: url(${bgImage[0]})">
        <h2 class="page__title">
          ${title.replace(/\n/gi, "<br />")}
        </h2>
         ${desc !== ""
            ? `<p class="page__desc">${desc.replace(/\n/gi, "<br />")} </p>`
            : ""}
        ${poster !== ""
            ? `
          <img class="page__poster" alt="${title}" src="${poster}"/>
        `
            : ""}
        <div class="page__mask"></div>
        ${i !== data.length - 1
            ? `
          <button class="page__arrow--down js-next">
            <svg class="svg--arrow-down svg" viewBox="0 0 15 15">
              <use href="#svg-arrow-down" xlinkHref="#svg-arrow-down" />
            </svg>
          </button>
        `
            : ""}
      </li>
    `;
    })
        .join("");
    return pages;
}
function generateDownloadBtn(config) {
    //没有配置信息或者下载文案为空，不显示下载按钮
    if (!config || !config.downloadText) {
        return;
    }
    return `
    <a
      class="page__download"
      href="${config.downloadLink}"
      dt-eid="icon"
      dt-params="${util_1.convertQueryToString({
        mod_id: "download_app",
        icon_type_tv: "txt",
        busModId: "download_app",
        mod_idx: 0,
        icon_name: "icon",
    })}"
    >
      <svg class="svg--download svg"  width="14px" height="15px">
        <use href="#svg-download" xlinkHref="#svg-download" />
      </svg>
      <span>
        ${config.downloadText.replace(/\n/gi, "<br />")}
      </span>
      <div class="page__qrcode">
        <canvas id="download-qrcode"></canvas>
      </div>
    </a>
  `;
}
function generateDownloadQRCode(config) {
    if (!config) {
        return;
    }
    const canvas = document.getElementById("download-qrcode");
    const { downloadLink } = config;
    if (canvas && downloadLink) {
        qrcode_1.default.toCanvas(canvas, downloadLink, {
            width: 86,
            height: 86,
            margin: 0,
        });
    }
}
function progressiveLoadingImg(img, urls) {
    if (!img) {
        return;
    }
    const progressiveUrls = Object.keys(urls);
    const loadImgUrl = () => {
        if (progressiveUrls.length === 0 && img.src !== prevUrl) {
            img.src = prevUrl;
            return;
        }
        prevUrl = progressiveUrls.shift();
        if (!img.src) {
            img.src = prevUrl;
            img.onload = loadImgUrl;
        }
        else {
            const tempImg = new Image();
            tempImg.src = prevUrl;
            tempImg.onload = loadImgUrl;
        }
    };
    let prevUrl = "";
    loadImgUrl();
}
function renderPages(data, container = document.getElementById("container")) {
    var _a;
    if (container) {
        const listContainer = container.children[0];
        const firstPageConfig = data[0];
        container.classList.add;
        container.classList[!((_a = ua_1.uaResult === null || ua_1.uaResult === void 0 ? void 0 : ua_1.uaResult.os) === null || _a === void 0 ? void 0 : _a.isMobile) ? "add" : "remove"]("pc");
        listContainer.insertAdjacentHTML("beforeend", generatePages(data));
        container.insertAdjacentHTML("beforeend", generateDownloadBtn(firstPageConfig));
        generateDownloadQRCode(firstPageConfig);
    }
    return container;
}
exports.renderPages = renderPages;
